import { Notification } from '@wellesley/openapi'
import eventsIcon from '../../icons/events.svg'
import followIcon from '../../icons/follower.svg'
import likeIcon from '../../icons/like.svg'
import mentionIcon from '../../icons/mention.svg'
import repostIcon from '../../icons/repost.svg'
import replyIcon from '../../icons/reply.svg'
import groupIcon from '../../icons/group.svg'
import pollIcon from '../../icons/poll.svg'

const getNotificationIcon = (notification: Notification) => {
  switch (notification.type) {
    case 'COMMENT':
      return replyIcon
    case 'FOLLOW':
    case 'FOLLOW_REQUEST':
      return followIcon
    case 'LIKE':
      return likeIcon
    case 'MENTION':
      return mentionIcon
    case 'REPOST':
      return repostIcon
    case 'EVENT_INVITE':
    case 'EVENT_JOIN':
    case 'EVENT_CANCEL':
    case 'EVENT_UPDATE':
      return eventsIcon
    case 'GROUP_INVITE':
      return groupIcon
    case 'POLL':
    case 'LIST_POST_CREATE':
    case 'POST_UPDATE':
    case 'POLL_VOTE':
      return pollIcon
  }
}

export default getNotificationIcon
